import { Select } from "@gw/web-basic-components";
import React from "react";
import type { InnerSelectProps } from "./dto";

/**
 * 表头下拉框
 */
const InnerSelect = (props: InnerSelectProps) => {
  const { ...restProps } = props;

  return (
    <Select showSearch showArrow size="mini" allowClear {...restProps}></Select>
  );
};

export default InnerSelect;
